import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Card, Row, Col, Button, Input, Modal } from "antd";
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";

const BASE_STATE_CONTACT = {
  name: "",
  title: "",
  email: "",
  work_phone: "",
  cell_phone: "",
  additional_details: "",
  seq: 1,
};
const BASE_STATE_CLIENT = {
  name: "",
  office_phone: "",
  fax: "",
  address_line_1: "",
  address_line_2: "",
  city: "",
  state: "",
  zip: "",
  additional_details: "",
  partner_xref: null,
  manager_xref: null,
  is_taxable: 0,
  payment_term: 30,
  client_categories_ids: [],
  client_contacts: [
    {
      name: "",
      title: "",
      email: "",
      work_phone: "",
      cell_phone: "",
      additional_details: "",
      seq: 1,
    },
  ],
  idemp_token: null,
};
function ModalAddClient(props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalWidth, setModalWidth] = useState(1200);
  const [client, setClient] = useState(BASE_STATE_CLIENT);
  const [users, setUsers] = useState([]);
  const [clientCategories, setClientCategories] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);

  const GetCompanySettings = async () => {
    let response = await props.AxiosRequest("/api/companies/get");
    setClient({ ...client, payment_term: response.data.company.default_payment_term });
  };

  const GetUsers = async () => {
    let response = await props.AxiosRequest("/api/user/get/all");
    setUsers(response.data.users);
  };

  const GetClientCategories = async () => {
    let response = await props.AxiosRequest("/api/client-categories/get");
    setClientCategories(
      response.data.data.map((m) => {
        return { ...m, label: m.name };
      }),
    );
  };

  const SaveClient = async () => {
    if (client?.name.length === 0) return props.MakeNotification("info", "Please enter the client's name.");
    if (isNaN(client?.payment_term)) return props.MakeNotification("info", "Please make sure payment term is a valid number.");
    if (client?.client_contacts.length === 0) return props.MakeNotification("info", "Please make sure there is at least one contact.");
    if (!client?.client_contacts[0].name) return props.MakeNotification("info", "Please make sure the contact has a name.");
    let response = await props.AxiosRequest("/api/clients/insert", { ...client });
    //Go To Client Details Page
    props.setAddModalProps({ open: false, refresh: true, tag: response.data.tag });
    setModalOpen(false);
    setClient({ ...BASE_STATE_CLIENT, client_contacts: [BASE_STATE_CONTACT] });
    setCurrentStep(0);
  };

  const next = () => {
    if (currentStep === 0 && !client?.name) return props.MakeNotification("warning", "Your client must have a name to continue");
    setCurrentStep(currentStep + 1);
  };
  const prev = () => {
    setCurrentStep(currentStep - 1);
  };
  const CancelAction = () => {
    props.setAddModalProps({ open: false });
    setModalOpen(false);
    setClient(BASE_STATE_CLIENT);
    setCurrentStep(0);
  };

  useEffect(() => {
    const resize = () => {
      const maxSize = Math.min(1200, window.innerWidth);
      setModalWidth(maxSize);
    };
    window.addEventListener("resize", resize);
  });

  useEffect(() => {
    setModalOpen(props.open);
    if (props.open) {
      setClient({ ...client, idemp_token: uuidv4() });
    }
    // if (client?.client_contacts.length === 0) setClient({ ...client, ] });
    // eslint-disable-next-line
  }, [props.open, props.client_id]);

  useEffect(() => {
    GetUsers();
    GetClientCategories();
    GetCompanySettings();
    // eslint-disable-next-line
  }, []);

  const steps = [
    {
      title: "Add Client Information",
      key: "first",
      content: (
        <>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={12}>
              <label className="col-form-label-sm">Client Name *</label>
              <Input
                className="form-control"
                value={client?.name}
                onChange={(e) => {
                  setClient({ ...client, name: e.target.value });
                }}
              />
            </Col>
            <Col span={12}>
              <label className="col-form-label-sm">Client Categories</label>
              <Select
                style={{ width: "100%" }}
                allowClear={true}
                isMulti
                options={clientCategories}
                value={client?.client_categories_ids}
                onChange={(e) => {
                  setClient({ ...client, client_categories_ids: e });
                }}
              />
            </Col>
            <Col span={24}>
              <hr />
              {/* address */}
              <h5 className="modal-title mb-3">Client Information </h5>
            </Col>
            <Col span={12}>
              <label className="col-form-label-sm">Home or Office Phone</label>
              <Input
                className="form-control"
                value={client?.office_phone}
                onChange={(e) => {
                  setClient({ ...client, office_phone: e.target.value });
                }}
              />
            </Col>
            <Col span={12}>
              <label className="col-form-label-sm">Fax</label>
              <Input
                className="form-control"
                value={client?.fax}
                onChange={(e) => {
                  setClient({ ...client, fax: e.target.value });
                }}
              />
            </Col>
          </Row>
          <hr />
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={12}>
              <label className="col-form-label-sm">Address Line 1</label>
              <Input
                className="form-control"
                value={client?.address_line_1}
                onChange={(e) => {
                  setClient({ ...client, address_line_1: e.target.value });
                }}
              />
            </Col>
            <Col span={12}>
              <label className="col-form-label-sm">Address Line 2</label>
              <Input
                className="form-control"
                value={client?.address_line_2}
                onChange={(e) => {
                  setClient({ ...client, address_line_2: e.target.value });
                }}
              />
            </Col>
            <Col span={12}>
              <label className="col-form-label-sm">City</label>
              <Input
                className="form-control"
                value={client?.city}
                onChange={(e) => {
                  setClient({ ...client, city: e.target.value });
                }}
              />
            </Col>
            <Col span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col span={10}>
                  <label className="col-form-label-sm">State</label>
                  <Input
                    className="form-control"
                    value={client?.state}
                    onChange={(e) => {
                      setClient({ ...client, state: e.target.value });
                    }}
                  />
                </Col>
                <Col span={14}>
                  <label className="col-form-label-sm">Zip</label>
                  <Input
                    className="form-control"
                    value={client?.zip}
                    onChange={(e) => {
                      setClient({ ...client, zip: e.target.value });
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <hr />
          <h5 className="modal-title mb-3">Misc. Information</h5>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={12}>
              <label className="col-form-label-sm">Client Partner</label>
              <Select
                style={{ width: "100%" }}
                allowClear={true}
                options={props.MakeUserOptions(users)}
                value={client?.partner}
                onChange={(e) => {
                  setClient({ ...client, partner_xref: e.value, partner: e });
                }}
              />
            </Col>
            <Col span={12}>
              <label className="col-form-label-sm">Client Manager</label>
              <Select
                style={{ width: "100%" }}
                allowClear={true}
                options={props.MakeUserOptions(users)}
                value={client?.manager}
                onChange={(e) => {
                  setClient({ ...client, manager_xref: e.value, manager: e });
                }}
              />
            </Col>
            <Col span={6}>
              {/* <label className="col-form-label-sm">Is Client Taxable?</label>
              <br />
              <Input
                className="form-check-Input"
                type="checkbox"
                checked={client?.is_taxable === 1 ? "checked" : ""}
                onChange={(e) => {
                  setClient({ ...client, is_taxable: e.target.checked ? 1 : 0 });
                }}
              /> */}
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Payment Term</label>
              <Input
                className="form-control"
                value={client?.payment_term}
                onChange={(e) => {
                  setClient({ ...client, payment_term: e.target.value });
                }}
              ></Input>
            </Col>
            <Col span={12}>
              <label className="col-form-label-sm">Additional Information</label>
              <textarea
                className="form-control"
                value={client?.additional_details}
                onChange={(e) => {
                  setClient({ ...client, additional_details: e.target.value });
                }}
              ></textarea>
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: "Add Contact Information",
      key: "second",
      content: (
        <>
          {client?.client_contacts.map((cc, i) => {
            return (
              <React.Fragment key={i}>
                <Card size="small" type="inner">
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col span={12}>
                      <h5 className="modal-title mb-3">{i === 0 ? "Primary Contact" : "Contact"}</h5>
                    </Col>
                    <Col span={12} className="text-right pull-right">
                      <div className="btn-group">
                        <button type="button" className="btn btn-light mb-1 dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          Actions&nbsp;
                        </button>
                        <div
                          className="dropdown-menu"
                          style={{ position: "absolute", inset: "0px auto auto 0px", margin: "0px", transform: "translate(0px, 35px)", dataPopperPlacement: "bottom-start" }}
                        >
                          <span
                            className="dropdown-item clickable"
                            onClick={() => {
                              setClient({
                                ...client,
                                client_contacts: client?.client_contacts.filter((f, f_i) => {
                                  if (f_i === i) return false;
                                  return true;
                                }),
                              });
                            }}
                          >
                            <FontAwesomeIcon className="pe-none" icon={faTrash} />
                            &nbsp; Delete Client
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    {/* title */}
                    <Col span={12}>
                      <label className="col-form-label-sm">Contact Name *</label>
                      <Input
                        className="form-control"
                        value={cc.name}
                        onChange={(e) => {
                          if (client?.name.length > 0)
                            setClient({
                              ...client,
                              client_contacts: client?.client_contacts.map((m, j) => {
                                if (i === j) return { ...m, name: e.target.value };
                                return m;
                              }),
                            });
                        }}
                      ></Input>
                    </Col>
                    <Col span={12}>
                      <label className="col-form-label-sm">Title</label>
                      <Input
                        className="form-control"
                        value={cc.title}
                        onChange={(e) => {
                          if (client?.name.length > 0)
                            setClient({
                              ...client,
                              client_contacts: client?.client_contacts.map((m, j) => {
                                if (i === j) return { ...m, title: e.target.value };
                                return m;
                              }),
                            });
                        }}
                      ></Input>
                    </Col>
                    <Col span={24}>
                      <hr />
                    </Col>
                    {/* address */}
                  </Row>
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col span={24}>
                      <h5 className="modal-title mb-2">Contact Information</h5>
                    </Col>
                    <Col span={24}>
                      <label className="col-form-label-sm">Email</label>
                      <Input
                        className="form-control"
                        value={cc.email}
                        onChange={(e) => {
                          if (client?.name.length > 0)
                            setClient({
                              ...client,
                              client_contacts: client?.client_contacts.map((m, j) => {
                                if (i === j) return { ...m, email: e.target.value };
                                return m;
                              }),
                            });
                        }}
                      ></Input>
                    </Col>
                    <Col span={12}>
                      <label className="col-form-label-sm">Work Phone</label>
                      <Input
                        className="form-control"
                        value={cc.work_phone}
                        onChange={(e) => {
                          if (client?.name.length > 0)
                            setClient({
                              ...client,
                              client_contacts: client?.client_contacts.map((m, j) => {
                                if (i === j) return { ...m, work_phone: e.target.value };
                                return m;
                              }),
                            });
                        }}
                      ></Input>
                    </Col>
                    <Col span={12}>
                      <label className="col-form-label-sm">Cell Phone</label>
                      <Input
                        className="form-control"
                        value={cc.cell_phone}
                        onChange={(e) => {
                          if (client?.name.length > 0)
                            setClient({
                              ...client,
                              client_contacts: client?.client_contacts.map((m, j) => {
                                if (i === j) return { ...m, cell_phone: e.target.value };
                                return m;
                              }),
                            });
                        }}
                      ></Input>
                    </Col>
                    <Col span={24}>
                      <label className="col-form-label-sm">Additional Details</label>
                      <textarea
                        className="form-control"
                        value={cc.additional_details}
                        onChange={(e) => {
                          if (client?.name.length > 0)
                            setClient({
                              ...client,
                              client_contacts: client?.client_contacts.map((m, j) => {
                                if (i === j) return { ...m, additional_details: e.target.value };
                                return m;
                              }),
                            });
                        }}
                      ></textarea>
                    </Col>
                  </Row>
                </Card>
                <br />
              </React.Fragment>
            );
          })}
          <br />
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="text-end" span={24}>
              <Button
                onClick={() => {
                  setClient({ ...client, client_contacts: [...client?.client_contacts, { ...BASE_STATE_CONTACT, seq: client?.client_contacts.length }] });
                }}
              >
                Add Another Contact
              </Button>
            </Col>
          </Row>
        </>
      ),
    },
  ];
  return (
    <>
      <Modal
        title="Add a New Client"
        centered
        open={modalOpen}
        onCancel={CancelAction}
        footer={
          currentStep === 0 ? (
            <>
              <Button onClick={CancelAction}>Cancel</Button>
              <Button type="primary" onClick={next}>
                Next
              </Button>
            </>
          ) : (
            <>
              <Button onClick={CancelAction}>Cancel</Button>
              <Button onClick={prev}>Previous</Button>
              <Button
                type="primary"
                onClick={() => {
                  SaveClient();
                }}
              >
                Add Client
              </Button>
            </>
          )
        }
        width={modalWidth}
      >
        {/* <Steps items={steps} current={currentStep} /> */}
        <br />
        <>{steps[currentStep].content}</>
      </Modal>
    </>
  );
}

export default ModalAddClient;
